import { DEFAULT_SCHEDULE_ORDER_BY } from 'common-data-handling';
import _, {identity} from 'lodash';
import {useMemo} from 'react';
import { useEventSchedule } from './useEventSchedule';

// -- //
/**
 * Returns selectable sessions that have no selection yet
 */

export function useSelectableUnselectedSessions(eventId, {filter = identity, sortBy = DEFAULT_SCHEDULE_ORDER_BY} = {}) {
    const schedule = useEventSchedule(eventId);
    return useMemo(
        () => _(schedule)
            .filter(session => session.is_selectable && !session.is_selected)
            .filter(session => !session.round_id || !schedule.find(s => s.round_id == session.round_id && s.is_selectable && s.is_selected))
            .filter(filter)
            .sortBy(sortBy)
            .value(),
        [schedule, filter, sortBy]
    );
}
